module.exports = __webpack_public_path__ + "media/images/LVNT-681ba19a90b7ac5b2605e45d27ce5ad8.png";